export const SENTRY_SEVERITY = {
    CRITICAL: "critical",
    HIGH: "high",
    MEDIUM: "medium",
    LOW: "low",
    UNKNOWN: "unknown",
};
export const SENTRY_ERROR_TYPE = {
    AUTH_INIT_FAILURE: "auth_init_failure",
    DATABASE_ERROR: "database_error",
    VALIDATION_ERROR: "validation_error",
    AUTH_ERROR: "auth_error",
    EXTERNAL_SERVICE_ERROR: "external_service_error",
    SCHEDULED_JOB_ERROR: "scheduled_job_error",
    AUTOMATION_CONFIG_MISSING: "automation_config_missing",
    UNKNOWN: "unknown",
};
export const DUMMY_ERROR_PREFIX = "EPORT-DUMMY-EXCEPTION:";
